import React, { useState } from 'react';
import { Star } from 'lucide-react';
import faceSocialImg from '../assets/face-social.jpg';
export function SocialProof() {
  const stats = [{
    value: '5+',
    label: 'Businesses'
  }, {
    value: '3000+',
    label: 'Transactions Matched'
  }, {
    value: '94.7%',
    label: 'Accuracy Rate'
  }, {
    value: '4.5h',
    label: 'Saved Per Week'
  }];
  return <section className="py-20 bg-gray-50 border-y border-gray-100" data-id="element-850">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-851">
        {/* Stats Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-20" data-id="element-852">
          {stats.map((stat, index) => <div key={index} className="text-center" data-id="element-853">
              <div className="text-4xl md:text-5xl font-bold text-violet-600 mb-2" data-id="element-854">
                {stat.value}
              </div>
              <div className="text-gray-600 font-medium" data-id="element-855">{stat.label}</div>
            </div>)}
        </div>

        {/* Testimonial */}
        <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-856">
          <div className="flex justify-center mb-6" data-id="element-857">
            {[...Array(5)].map((_, i) => <Star key={i} className="h-6 w-6 text-yellow-400 fill-current" data-id="element-858" />)}
          </div>
          <blockquote className="text-2xl md:text-3xl font-medium text-gray-900 leading-relaxed mb-6" data-id="element-859">
            "Berry Finance has completely transformed how we handle our monthly
            close. What used to take me two days, and now it only takes about an hour. It feels like
            like magic during Tax season."
          </blockquote>
          <div className="flex items-center justify-center space-x-4" data-id="element-860">
            <div className="w-12 h-12 bg-gray-200 rounded-full overflow-hidden" data-id="element-861">
              {/* Placeholder avatar */}
              <div className="w-full h-full" data-id="element-862">
                <img src={faceSocialImg} alt="an Image of a woman" className="w-full h-full" data-id="element-863" />
              </div>
            </div>
            <div className="text-left" data-id="element-864">
              <div className="font-bold text-gray-900" data-id="element-865">Sarah Jenkins</div>
              <div className="text-gray-600 text-sm" data-id="element-866">Accountant Consultant at Initech Inc.</div>
            </div>
          </div>
        </div>

        {/* Logos */}
        <div className="text-center" data-id="element-867">
          <p className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-8" data-id="element-868">
            Trusted by finance teams at
          </p>
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-50 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-869">
            {/* Text-based logo placeholders for simplicity */}
            {/* <span className="text-2xl font-bold text-gray-600">ACME Corp</span> */}
            {/* <span className="text-2xl font-bold text-gray-600 font-serif">
             Globex
             </span>
             <span className="text-2xl font-bold text-gray-600">Soylent</span> */}
            <span className="text-2xl font-bold text-gray-600 font-mono" data-id="element-870">
              <a className='hover:text-gray-900' href="https://www.linkedin.com/company/initechinfo/" data-id="element-871">Initech</a> 
            </span>
            {/* <span className="text-2xl font-bold text-gray-600 italic">
             Umbrella
             </span> */}
          </div>
        </div>
      </div>
    </section>;
}